import React from "react";
import { Link } from "react-router-dom";
import { ledgerArticles } from "../../data/ledger";
import { SectionLabel } from "../SectionLabel";
export function HomeSignals() {
  const article = ledgerArticles.find(a => a.featured) ?? ledgerArticles[0];
  return <section aria-label="Research and The Ledger" className="shell pb-8" data-id="element-174" data-mp="25xco5tr30ns0">
      <div className="grid grid-cols-1 border-t border-navy md:grid-cols-2" data-id="element-175" data-mp="212fkz3ghh8n1">
        <div className="py-12 md:pr-12 lg:pr-16" data-id="element-176" data-mp="2yn1tgjatr9zf">
          <SectionLabel data-id="element-177" data-mp="2tpa1xqe3dpvr">Research & Intelligence</SectionLabel>
          <p className="mt-5 max-w-md font-display text-2xl leading-snug text-navy md:text-[1.75rem]" data-id="element-178" data-mp="2tpt869udqpty">
            We study how payroll operations and HR technology actually work — and publish what we learn.
          </p>
          <Link to="/research" className="link-rule mt-8" data-id="element-179" data-mp="2kqoephxodmon">
            Explore Research →
          </Link>
        </div>

        <div className="border-t border-stone py-12 md:border-l md:border-t-0 md:pl-12 lg:pl-16" data-id="element-180" data-mp="199ok2fnuuvrg">
          <SectionLabel data-id="element-181" data-mp="281mgze2uz6ls">From The Ledger</SectionLabel>
          <p className="mt-5 max-w-md font-display text-2xl leading-snug text-navy md:text-[1.75rem]" data-id="element-182" data-mp="281w854zn3jt2">{article.title}</p>
          <p className="mt-3 max-w-md text-[15px] leading-relaxed text-charcoal/75" data-id="element-183" data-mp="2cyd5mpsqbait">{article.dek}</p>
          <Link to="/ledger" className="link-rule mt-8" data-id="element-184" data-mp="1z312pv4f6dqt">
            Read →
          </Link>
        </div>
      </div>
    </section>;
}